import { render, staticRenderFns } from "./ClientEditTabBranding.vue?vue&type=template&id=f6d73bfa&"
import script from "./ClientEditTabBranding.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabBranding.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabBranding.vue?vue&type=style&index=0&id=f6d73bfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports